import React from 'react'
import debounce from 'lodash/debounce'

class TranslationRowInput extends React.Component {
  state = {
    value: this.props.value
  }

  submitChange = () => {
    const { lang, topic, transKey, path } = this.props

    this.props.updateTranslation(lang, topic, transKey, this.state.value, path)
  }

  submit = debounce(() => this.submitChange(), 1000)

  handleChange = e => {
    this.setState({
      value: e.target.value
    })

    this.submit()
  }

  render() {
    const { transKey } = this.props

    return (
      <div className="tl-translation-row">
        <div className="tl-translation-row__key">{transKey}</div>
        <input
          onChange={this.handleChange}
          value={this.state.value}
          className="tl-translation-row__input"
        />
      </div>
    )
  }
}

export default TranslationRowInput
